export default __webpack_public_path__ + "static/media/viciousstrike1.3a468d14.png";